import * as sys from "./index"
//推荐广告埋点 上报
const writeADScript = (obj) => {
  let src = obj.src
  if (document.getElementById(obj.scriptId)) {
    setTimeout(() => {
      initRecADCC(obj.id)
    })
  } else {
    let script = document.createElement('script')
    script.type = 'text/javascript'
    script.setAttribute('id', obj.scriptId)
    script.onload = () => {
      initRecADCC(obj.id)
    }
    script.src = src
    document.body.appendChild(script)
  }
}
// 初始化加载广告统计
const initRecADCC = (id) => {
  if (CC) {
    CC.destroy()
    CC.cc({
      reco_id: id
    })
  }
}

// 获取URL中的get参数
let timeStamp = '' // 缓存加密时间戳
const getGetParams = () => {
  const url = window.document.location.href.toString()
  if (!timeStamp) timeStamp = new Date().getTime() // 时间戳
  let u = url.split('?')
  if (typeof (u[1]) === 'string') {
    if (u[1].indexOf('#') !== -1) {
      u = u[1].split('#')
      u = u[0].split('&')
    } else {
      u = u[1].split('&')
    }
    let get = {}
    for (let a = 0, b = u.length; a < b; a++) {
      let j = u[a].split('=')
      if (j[0]) {
        get[decodeURIComponent(j[0])] = decodeURIComponent(j[1])
      } else if (j[1]) {
        get[decodeURIComponent(j[1])] = ''
      }
    }
    // 优先取接口返回的时间戳
    if (!get.timestamp) get.timestamp = timeStamp
    else timeStamp = get.timestamp
    return get
  } else {
    return { timestamp: timeStamp, user_client: 'touch', client_version: '1.0', unionid: '' }
  }
}
const $_GET = getGetParams()

/**
 * 同步获取UDID
 * @return udid
 */
const getUdidSync = () => {
  return sys.cookie.get('MDD_sid') || ''
}


export { writeADScript, $_GET, getUdidSync }
